<script>
import BridgeUpload from './bridge-upload'
import ValidateMixin from './mixins/validate'

export default {
  name: 'RnrFile',
  components: { BridgeUpload },
  mixins: [ValidateMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => ([])
    },
    attrs: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    size: {
      type: String,
      default: 'small'
    },
    maxCount: {
      type: Number,
      default: 1
    },
    compress: {
      type: Object,
      default: null
    },
    api: {
      type: Function,
      default: () => {}
    },
    validateCallback: {
      type: Function,
      default: null
    }
  },
  methods: {
    /**
     * 当图片发生改变的方法
     */
    handleImageChange(value) {
      this.$emit('input', value)
      // 界面渲染完成后开始校验数据
      this.$nextTick(this.validate)
    }
  },
  render() {
    return this.label ? (
      <van-cell
        required={this.required}
        title={this.label}
        class={`van-field rnr-file ${this.size === 'small' ? 'wrapper-small' : 'wrapper-large'}`}
        scopedSlots={{
          label: () => {
            return (
              <bridge-upload compress={this.compress} api={this.api} maxCount={this.maxCount} value={this.value} onInput={this.handleImageChange}>
                <div class='upload-wrapper'>
                  <div class='icon-upload-camera' />
                </div>
              </bridge-upload>
            )
          }
        }}
      />
    ) : (
      <div class={`rnr-file ${this.size === 'small' ? 'wrapper-small' : 'wrapper-large'}`}>
        <bridge-upload compress={this.compress} api={this.api} maxCount={this.maxCount} value={this.value} onInput={this.handleImageChange}>
          <div class='upload-wrapper'>
            <div class='icon-upload-camera' />
          </div>
        </bridge-upload>
      </div>
    )
  }
}
</script>

<style lang="scss">
.rnr-file {
  .upload-wrapper {
    background-color: #F7F8FA;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
  }
  .icon-upload-camera {
    background-image: url(./assets/ico_camera.png);
    background-size: 100% 100%;
    position: absolute;
    width: 80px;
    height: 80px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .van-uploader__preview-delete {
    border-radius: 0 0 0 22px;
    width: 32px;
    height: 32px;
    .van-uploader__preview-delete-icon {
      font-size: 32px;
      top: 0;
      right: -2px;
    }
  }
  &.wrapper-small {
    .upload-wrapper {
      background-image: url(./assets/ico_pic.png);
      background-size: 196px 196px;
      border-radius: 8px;
      width: 196px;
      height: 196px;
    }
    .van-uploader__preview {
      margin: 0 24px 16px 0;
      .van-uploader__preview-image {
        width: 196px;
        height: 196px;
      }
      .van-uploader__preview-delete {
        background-color: rgba(0, 0, 0, .4);
        border-radius: 20px;
        display: flex;
        width: 40px;
        height: 40px;
        .van-uploader__preview-delete-icon {
          font-size: 60px;
          top: -10px;
          right: -10px;
        }
      }
      &:nth-child(3) {
        margin-right: 0px;
      }
    }
  }
  &.wrapper-large {
    .van-uploader__input-wrapper {
      margin: 0 auto;
      .upload-wrapper {
        background-image: url(./assets/ico_pic_large.png);
        background-size: 100% 100%;
        width: 638px;
        height: 322px;
      }
    }
    .van-uploader__preview {
      width: 638px;
      height: 322px;
      margin: 0 auto;
      overflow: hidden;
      margin-bottom: 64px;
      .van-uploader__preview-image {
        width: 100% !important;
        height: 100% !important;
      }
      .van-uploader__preview-delete {
        background-color: rgba(0, 0, 0, .4);
        border-radius: 20px;
        display: flex;
        width: 40px;
        height: 40px;
        .van-uploader__preview-delete-icon {
          font-size: 60px;
          top: -10px;
          right: -10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FormRender/file.vue